const url = '/audit/sicc/obrigacao/revisao'

export function buscarLogPorObrigacao(id) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/${id}`).then((res) => {
      resolve(res.data);
    });

  });
}
